import React from 'react';
import sharePost from '../../assets/images/sharePost.png';

const SharePost = ({link, closeModal}) => {

    const text1 = 'I just hit 10,000 $JETs on JetApp for joining early.';
    const text2 = 'I could tell you everything, but it’s way more fun to find out on your own.';
    const text3 = 'Let’s see who fills their wallet faster! 🚀';
    const mainText = encodeURIComponent(`\n${text1}\n${text2}\n${text3}`)

    return (
        <div className="sharePost-container">
            <img alt="Jace Affiliation program" src={sharePost} className="sharePost-image"/>
            <p className="text-white fs14 text-left font-bold mt20">{text1}</p>
            <p className="text-white fs14 text-left">{text2}</p>
            <p className="text-white fs14 text-left">{text3}</p>
            <p className="fs14 text-left sharePost-link">{link}</p>
            <a href={`https://t.me/share/url?url=${link}&text=${mainText}`} target="_blank" className={`button3 ${link ? '' : 'disabledBtn disabledLink'}`} role="button" rel="noopener noreferrer" onClick={closeModal}>
                Share & Earn
            </a>
        </div>
    );
}

export default SharePost;

